import { axios, fileAxios, axiosPersonal } from '../plugins/axios';
import http from '../services/http-handler.service';

export default {
  namespaced: true,

  state: {
    personal: [],
    personalFotoCuip: null,
    personalSingle: null,
    savedIdPersonal: 0,
  },

  getters: {
    getPersonal: (state) => state.personal.filter((personal) => personal.nombre !== ''),

    getPersonalFotoCuip: (state) => state.personalFotoCuip,

    getPersonalSingle: (state) => state.personalSingle,

    getSavedIdPersonal: (state) => state.savedIdPersonal,
  },

  mutations: {
    SET_PERSONAL(state, personal) {
      state.personal = personal;
    },

    SET_PERSONAL_FOTO_CUIP(state, idPersonal) {
      const personalFotoCuip = state.personal.filter(
        (personal) => personal.idPersonal === idPersonal,
      );

      const personal = { ...personalFotoCuip[0] };

      state.personalFotoCuip = personal;
    },

    SET_PERSONAL_SINGLE(state, personalSingle) {
      state.personalSingle = personalSingle;
    },

    SET_SAVED_PERSONAL_ID(state, idPersonal) {
      state.savedIdPersonal = idPersonal;
    },
  },

  actions: {
    async fetchPersonal({ commit }) {
      await axios
        .get('PoliciaCuadrantes/EstadoFuerza/personal')
        .then((response) => {
          commit('SET_PERSONAL', response.data.data);
        });
    },

    async fetchPersonalByCuip({ commit }, cuip) {
      await axios
        .get(`PoliciaCuadrantes/EstadoFuerza/personal/${cuip}`)
        .then((response) => {
          commit('SET_PERSONAL_SINGLE', response.data.data[0]);
        });
    },

    async updatePersonal(context, personal) {
      await axios
        .put(`PoliciaCuadrantes/EstadoFuerza/personal/${personal.idPersonal}`, personal)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Información de elemento actualizada correctamente.', {
            root: true,
          });
        });
    },

    async updatePersonalEdoFuerza(context, personal) {
      const clonedPersonal = { ...personal };

      delete clonedPersonal.CatAduana;
      delete clonedPersonal.CatArea;
      delete clonedPersonal.CatEstGradoHomologado;
      delete clonedPersonal.CatEstadoCivil;
      delete clonedPersonal.CatEstatus;
      delete clonedPersonal.CatGrupoSanguineo;
      delete clonedPersonal.CatHabilitado;
      delete clonedPersonal.CatMotivoBaja;
      delete clonedPersonal.CatMunicipioNacimiento;
      delete clonedPersonal.CatMunicipioRadica;
      delete clonedPersonal.CatNivel;
      delete clonedPersonal.CatPuestoDependencia;
      delete clonedPersonal.CatRamaDependencia;
      delete clonedPersonal.CatSexo;
      delete clonedPersonal.CatSubArea;
      delete clonedPersonal.CatSubSede;
      delete clonedPersonal.CatTipoFuncion;
      delete clonedPersonal.CatTipoNacionalidad;
      delete clonedPersonal.CatTipoRecurso;
      delete clonedPersonal.CatTurno;
      await axiosPersonal
        .put(`PoliciaCuadrantes/EstadoFuerza/personal/${personal.idPersonal}`, clonedPersonal)
        .catch(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Ocurrió un error al intentar vinculación de expediente con aplicación Personal SSC.', {
            root: true,
          });
        });
    },

    async savePersonal(context, personal) {
      await axios
        .post('PoliciaCuadrantes/EstadoFuerza/personal', personal)
        .then((response) => {
          context.commit('SET_SAVED_PERSONAL_ID', response.data.data[0].ID);
        });
    },

    async updatePuestoPersonal(_, puesto) {
      await axios
        .put(`PoliciaCuadrantes/EstadoFuerza/personal/${puesto.idPersonal}/puesto`, {
          fk_idPuestoDependencia: puesto.idPuestoDependencia,
        });
    },

    async updateAreaPersonal(_, area) {
      await axios
        .put(`/PoliciaCuadrantes/EstadoFuerza/personal/${area.idPersonal}/areas`, {
          fk_idCatArea: area.fk_idCatArea,
        });
    },

    async updateSubsedePersonal(context, subsede) {
      await axios
        .put(`PoliciaCuadrantes/EstadoFuerza/personal/${subsede.idPersonal}/subsede`, {
          fk_idSubsede: subsede.idSubsede,
        })
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Asignación de subsede y puesto realizada correctamente.', {
            root: true,
          });
        });
    },

    async uploadFoto(_, formData) {
      await fileAxios
        .post('/Fotografia/uploadPhotograph', formData)
        .then(() => {});
    },

    async saveCuip(context, personalCuip) {
      await axios
        .put(`PoliciaCuadrantes/EstadoFuerza/personal/${personalCuip.idPersonal}/cuip`, {
          CUIP: personalCuip.CUIP,
        })
        .then(() => {});
    },

    async searchPersonal(_, employeeNumber) {
      const personal = await http.create('/EonCloud/EstadoFuerza/search/personal', {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        curp: '',
        CUIP: employeeNumber,
      });
      return personal;
    },
  },
};
